// import * as Sentry from '@sentry/vue'
// import store from '@/vuex/store'

let wakeLock = null

const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen')
    // wakeLock.addEventListener('release', () => {
    //   // do nothing
    // })
  } catch {
    // no need handle sentry
    // Sentry.captureException(new Error('Error requestWakeLock'), {
    //   extra: {
    //     err,
    //     presentationId: store.state.presentation.id,
    //     userId: store.state.currentUser.id,
    //   },
    // })
  }
}

const releaseWakeLock = async () => {
  try {
    if (wakeLock) {
      await wakeLock.release()
      wakeLock = null
    }
  } catch {
    // no need handle sentry
    // Sentry.captureException(new Error('Error releaseWakeLock'), {
    //   extra: {
    //     err,
    //     presentationId: store.state.presentation.id,
    //     userId: store.state.currentUser.id,
    //   },
    // })
  }
}

export default {
  requestWakeLock,
  releaseWakeLock,
}
